<template>
    <v-container>
        <v-card class="card-contain" style="background-color: #F5F5F5">
            <v-card-text>
                <div class="d-flex flex-column align-center justify-center">
                    <img src="@/assets/images/not-availabel/tutup.png" height="80" width="80" alt="no data">
                    <span class="font-weight-bold" style="color: #000;font-size: large;">
                        {{ title }}
                    </span>
                    <span class="font-weight-normal mb-4">
                        {{ description }}
                    </span>
                    <v-btn v-if="!hideBtn" elevation="1" color="white" style="text-transform: capitalize;font-weight: 700;" @click="onClick">{{ $t('text_view_nearby_date') }}</v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'TemporalyClosed',
    props: {
        hideBtn: {
            type: Boolean,
            default: false,
        },
        title: String,
        description: String,
    },
    methods: {
        onClick() {
            this.$emit('click');
        }
    }
}
</script>